var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgHistory = function SvgHistory(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 16
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M10.67.036c3.676.341 6.71 3.174 7.241 6.758.012.082.059.16.089.239v1.864c-.092.401-.17.806-.278 1.203-1.552 5.747-8.829 7.84-13.276 3.82-.088-.08-.189-.146-.26-.2l1.282-1.247c1.383 1.231 3.06 1.9 5.02 1.722a6.175 6.175 0 0 0 3.83-1.758 6.152 6.152 0 0 0 1.119-7.39c-1.322-2.408-4.146-3.706-6.802-3.128C6.087 2.473 3.921 4.58 3.77 6.7l1.951-.267-2.873 3.973L0 6.433l1.854.25c.143-.493.252-.967.415-1.422 1.223-3.407 4.706-5.569 8.4-5.225zm3.433 6.211c-.034.455-.28.7-.66.848-.918.357-1.838.707-2.743 1.092-.188.08-.367.28-.456.467-.206.44-.352.908-.529 1.362-.22.567-.609.776-1.106.604-.54-.188-.776-.654-.586-1.199.234-.668.46-1.341.74-1.992.095-.222.305-.46.524-.555 1.16-.507 2.337-.98 3.515-1.449.675-.269 1.317.165 1.3.822z"
  })));
};

export default SvgHistory;